// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://txvcebqjzspxbhdbbepa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR4dmNlYnFqenNweGJoZGJiZXBhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg4MTMwMTQsImV4cCI6MjA3NDM4OTAxNH0.JRXIYipYGbXP7l_jV6H35pFplW8LioeNHTU9J6m36o8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});